import React from "react";
import { Navbar, Container, Nav } from "react-bootstrap";
import { NavLink, useNavigate } from "react-router-dom";
import { Home } from "lucide-react";

function NoOneNavbar() {
  const navigate = useNavigate();
  function TempLocalHandel(){
    localStorage.removeItem("currentUser");
    navigate('/');
  }
  return (
    <Navbar bg="light" expand="lg" fixed="top" className="shadow-sm px-4 py-2">
      <Container
        fluid
        className="d-flex justify-content-between align-items-center"
      >
        {/* Logo + Title */}
        <div className="d-flex align-items-center">
          <img
            src="/CampusPulsLogo.png"
            alt="CampusPulse Logo"
            style={{ height: "50px", width: "auto", objectFit: "contain" }}
            className="me-2"
          />
          <h4
            style={{
              background: "linear-gradient(90deg, #007bff, #6610f2)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              fontWeight: "800",
              letterSpacing: "0.8px",
              margin: 0,
              fontSize: "10px",
            }}
          >
            CampusPulse
          </h4>
        </div>

        {/* Single Nav Link */}
        <Nav className="ms-auto">
          <Nav.Link
            as={NavLink}
            to="/"
            className="d-flex align-items-center fw-semibold text-primary"
            onClick={TempLocalHandel}
          >
            <Home size={20} className="me-2" />
            START
          </Nav.Link>
        </Nav>
      </Container>
    </Navbar>
  );
}

export default NoOneNavbar;
